import { ref, onMounted, onBeforeUnmount } from 'vue';

export const useScreenSize = () => {
  const isLg = ref(window.innerWidth > 850);
  const isSm = ref(window.innerWidth >= 640); // Tailwind sm breakpoint

  const handleWindowResize = () => {
    isLg.value = window.innerWidth > 850;
    isSm.value = window.innerWidth >= 640;
  };

  onMounted(() => {
    handleWindowResize();
    window.addEventListener('resize', handleWindowResize);
  });

  onBeforeUnmount(() => {
    window.removeEventListener('resize', handleWindowResize);
  });

  return { isLg, isSm };
};

export const useScreenSizeInCatalog = () => {
  const isLg = ref(window.innerWidth > 750);

  const handleWindowResize = () => {
    isLg.value = window.innerWidth > 750;
  };

  onMounted(() => {
    handleWindowResize();
    window.addEventListener('resize', handleWindowResize);
  });

  onBeforeUnmount(() => {
    window.removeEventListener('resize', handleWindowResize);
  });

  return { isLg };
};
